module.exports = __webpack_public_path__ + "static/media/avatar-2.bb163c3f.png";